import { keyBy } from "../../assets/js/utils";
import { getText, appendText } from "../../assets/js/text-renderer";
import "../../assets/js/form-submit";
import "./contacto.scss";

document.addEventListener("DOMContentLoaded", function () {
  if (
    DEVELOPMENT ||
    (window["__PRERENDER_INJECTED"] &&
      window["__PRERENDER_INJECTED"].render_text)
  )
    loadText();
});

function loadText() {
  getText("extras/contact/").then(function (dict) {
    const texts = keyBy(dict.stories, "slug");

    appendText(texts.datos.content.title, "datos-title");
    appendText(texts.datos.content.description, "datos-description");
    appendText("Enviar", "form-submit");

    window.dispatchEvent(
      new CustomEvent("rendered-text", {
        detail: "content",
      })
    );
    window.dispatchEvent(
      new CustomEvent("rendered-text", {
        detail: "cta",
      })
    );
  });

  getText('shared/keywords').then(function (dict) {
    const texts = dict.stories[0].content;
    // console.log(texts);
    appendText(texts.formulario_contacto, "formulario-contacto");
    appendText(texts.te_llamamos, "te-llamamos");
    appendText(texts.nombre, "nombre-l");
    appendText(texts.email, "email-l");
    appendText(texts.telefono, "telefono-l");
    appendText(texts.empresa, "empresa-l");
    appendText(texts.mensaje, "mensaje-l");
    appendText(texts.leido_politica, "leido-politica-privacidad");
    appendText(texts.politica_privacidad, "politica-privacidad");
    appendText(texts.acepte_politica, "policy-accept");

    window.dispatchEvent(
      new CustomEvent("rendered-text", {
        detail: "keywords",
      })
    );
  });
}
